import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './SearchBar.css';

class SearchBar extends Component {

    inputChangedHandler = (event) => {
            this.props.onDataChanged(event.target.value);
    }
    
    render () {
        return (
        <div className={classes.SearchBar}>
            <h4>Search Criteria</h4>
            <div className={classes.Inline}>
                <div className={classes.SearchCriteria}>
                    <input autoFocus='true' placeholder="Search For" type="text" value={this.props.searchCriteria        } onChange={(event) => this.inputChangedHandler(event)} />
                </div>
                <div className={classes.Button}>
                <button
        className={classes.Button}
        onClick={this.props.onSearch}>Search</button>
                </div>
            </div>
        </div>
        );
         };

};

const mapStateToProps = state => {
 
    return {
        searchCriteria: state.orders.SearchCriteria
    };
}


export default connect(mapStateToProps)(SearchBar);


// WEBPACK FOOTER //
// ./src/components/UI/SearchBar/SearchBar.js